// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1pOVQ","header":"MergedInvoice_header__26oK4"};